import { render, staticRenderFns } from "./OrganizationSettingsMembers.vue?vue&type=template&id=344cbe6e&scoped=true"
import script from "./OrganizationSettingsMembers.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganizationSettingsMembers.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./OrganizationSettingsMembers.vue?vue&type=style&index=0&id=344cbe6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "344cbe6e",
  null
  
)

export default component.exports